(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    if(document.querySelectorAll('.search-term').length > 0){
    document.querySelectorAll('.search-term').forEach(function(elem){
      elem.onclick = function(){
        let text = elem.innerText;
        document.querySelector('.search-input').value = text;
        document.querySelector('.search-input').dispatchEvent(new Event('input keydown', { bubbles: true }));
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
